import { filterOptions } from '@/utils/query-base'

const textFilter = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  product_id: {
    title: '产品编码',
    type: 'input',
    equation: textFilter,
    width: 180
  },
  product_name: {
    title: '产品名称',
    type: 'input',
    equation: textFilter,
    width: 200
  }
}

export default {
  parameter2: {
    title: '序号',
    width: 120,
    visible: false
  },
  parameter3: {
    title: '产品编码',
    width: 160,
    slot: true
  },
  product_name: {
    title: '产品名称',
    width: 220,
    slot: true
  },
  parameter4: {
    title: '最小订单件数',
    width: 140
  },
  parameter5: {
    title: '最大订单件数',
    width: 140
  },
  active: {
    title: '状态',
    width: 120,
    slot: true,
    align: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/views/product-manage/config/groupPurchaseProduct.js